import { draw } from './draw'
import { resize } from './resize'
import { drag } from './drag'
import { rotate } from './rotate'
import { focus } from './focus'

export const mouseMoveActions = {
  draw,
  resize,
  drag,
  rotate,
  focus,
}



// WEBPACK FOOTER //
// ./src/drawing/core/mouseMove/index.js